<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.address.title' | translate"
  [description]="'organizer.edit.address.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="address.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateAddress()"
>
  <app-tips
    class="block mb-5"
    [title]="'organizer.edit.address.tips.title' | translate"
    [tips]="'organizer.edit.address.tips.description' | translate"
    [icon]="iconType.WarningError"
    [variant]="tipsVariant.WARNING"
  ></app-tips>

  <app-form-address [formControl]="address" [location]="address.value">
  </app-form-address>
</app-organizer-shared-layout-edit-field>
